<template>
  <div>
    <div id="uoloaddiv33" align="left">
      <!-- 隐藏电台相关注释
			<div style="padding:10px 0;">

			<el-button type="button" @click="diantaidialogVisible = true" class="margingbot10">添加临时网络电台</el-button>
			 </div>
			 <div style="padding:10px 0;">
			 <el-tag type="danger">
				 如果是4G且定向流量卡无法使用通用流媒体地址。联系技术人员给搭建流媒体服务器/流媒体服务地址列表详情见系统发布列表清单;
				</el-tag>

				 <el-tag type="danger">支持国内常见已收录的所有电台及地方电台国内开放的国外电台.电台引用属于用户个人行为，我司不承担任何责任.如需搭建企业/组织机构以及商用电台可联系我们.
			 </el-tag>
			 </div>
			<el-dialog title="添加电台节目信息:" :visible.sync="diantaidialogVisible" width="30%">
			  <el-form   label-width="80px">
         隐藏电台相关注释-->

<!-- 					<el-form-item label="知名电台">
						<el-select v-model="value" placeholder="请选择">
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item> -->
  <!-- 隐藏电台相关注释
					  <el-form-item label="电台名字">
							<el-input v-model="diantainame" maxlength="10" show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="流媒地址">
							 	<el-input v-model="diantaiurl" maxlength="100" show-word-limit></el-input>
					  </el-form-item>
						<el-form-item label="电台时长">
							<el-tooltip class="item" effect="dark" content="电台时长最低60秒[1分钟] 最长3600秒[60分钟]部分老款设备最长支持5分钟" placement="left-start">
						<el-input-number placeholder="3600" v-model="diantailen" :min="60" :max="3600" show-word-limit>
				  </el-input-number>
					 </el-tooltip>
						</el-form-item>
				</el-form>

			  <span slot="footer" class="dialog-footer">
			    <el-button @click="diantaidialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="click_shenqingdiantai">确 定</el-button>
			  </span>
			</el-dialog>
 隐藏电台相关注释 -->
      <el-upload
        class="upload-demo"
        :action="actions"
        :onSuccess="uploadSuccess"
        :on-error="uploadError"
        :before-upload="uploadbefore"
        :file-list="fileList"
        :data="uploaddata"
      > <el-button
          id="topbuttn"
          size="big"
          icon="el-icon-upload2"
          type="primary"
        >点击上传 只能上传Mp3文件，且单个文件不超过15M【文件上传解析校验会持续比较久耐心等待】</el-button>

        <div slot="tip" class="el-upload__tip"></div>
      </el-upload>
      <el-button
          size="big"
           @click="get_file_list"
        > 刷新文件列表 </el-button>
      <div style="padding:10px 0;">
        <a-player
          :autoplay="autoplay"
          :music="songList"
          v-if="flag"
          mutex
          listmaxheight="10px"
          ref="player"
        ></a-player>
      </div>


      <el-table :data="tableDatafilelist" highlight-current-row border style="width: 1000px">
        <el-table-column type="index" width="100" label="编号"></el-table-column>
        <el-table-column prop="filename" label="文件名" width="300">
        </el-table-column>
        <el-table-column prop="sizeStr" label="文件大小" width="100"></el-table-column>
        <el-table-column label="试听" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="playurl(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >播放</el-button>
             <el-link  :href="tableDatafilelist[scope.$index].url" type="success"  >右键另存为</el-link>
          </template>
        </el-table-column>
   <!--     <el-table-column  label="审核状态" width="100" align="center">
                <template slot-scope="scope">
                <el-switch    :disabled="tableDatafilelist[scope.$index].ismasterd == 1 ? true:false"
                  active-value="1"
                  inactive-value="0"
                  v-model="tableDatafilelist[scope.$index].enable"
                  @change="abletask( scope.$index, tableDatafilelist)"
                ></el-switch>
                </template>
                </el-table-column> -->
                <!-- <el-table-column  label="共享状态" width="100" align="center" v-if="isroot">
                  <template slot-scope="scope">
                    <el-switch
                      active-value="1"
                      inactive-value="0"
                      v-model="tableDatafilelist[scope.$index].ziuse"
                      @change="shelltask( scope.$index, tableDatafilelist)"
                    ></el-switch>
                  </template>
            </el-table-column> -->
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button :disabled="tableDatafilelist[scope.$index].ismasterd == 1 ? true:false"
              @click.native.prevent="deleteRow(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import VueAplayer from "vue-aplayer";
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  components: {
    //别忘了引入组件
    "a-player": VueAplayer
  },
  data() {
    return {
      flag: false,
      actions: "",
			diantailen:60,
      actionsmp3: "",
			diantaidialogVisible:false,
      userid: 0,
      fileList: [],
      tableDatafilelist: [],
      songList: [],
			diantaiurl:"",
			diantainame:"",
      autoplay: false,
      isroot: false,
			options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        uploaddata:{}
    };
  },
  created() {
    this.userid = sessionStorage.getItem("id");
    this.actions ="/user/uploadfile";
    this.get_file_list();
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }else{
			this.isroot = false;
		}
  },
  methods: {
    uploadbefore(file) {
      var fileName = new Array();
      fileName = file.name.split(".");
      const extension =  fileName[fileName.length - 1] === "mp3";
      const extension2 = fileName[fileName.length - 1] === "MP3";
      const isLt2M = file.size / 1024 / 1024 < 40;
      fileName = file.name.split(".");
      this.uploaddata.id =  sessionStorage.getItem("id");
      this.uploaddata.token = sessionStorage.getItem("token");//name
      this.uploaddata.name = fileName;
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是MP3格式!",
          type: "warning"
        });
        return false;
      }
      if ( !isLt2M ) {
        this.$message({
          message: "上传文件大小不能超过 40MB!",
          type: "warning"
        });
        return false;
      }
      return true;
    },
		click_shenqingdiantai(){
			if(this.diantaiurl.length<10){
				return;
			}
			if(this.diantailen <60 || this.diantailen > 3600){
				return;
			}
			if(this.diantainame.length==0){
				return;
			}
				 var baseurl = Base64.encode(this.diantaiurl) ;
				 var basename = Base64.encode(this.diantainame) ;
				axios
				  .get("/uploader_fordiantai.php", {
				    params: {
				      username: sessionStorage.getItem("username"),
				      passwd: sessionStorage.getItem("passwd"),
							kind:"mp3",
							len:this.diantailen,
							url:baseurl,
							name:basename
				    }
				  })
				  .then(
				    function(res) {
				      if (res.data.res) {
									this.$message({
									  type: "success",
									  message: "添加成功!" + this.diantainame
									});
									this.diantaidialogVisible =false;
									this.get_file_list();

				      }else{
									this.$message({
									  type: "warming",
									  message: "添加失败!检查是否已重复添加及规范" + this.diantainame
									});
									this.diantaidialogVisible =false;
							}
				    }.bind(this)
				  )
				  .catch(function(res) {
				    console.log(res);
				  });

		},
    playurl(index, rows) {
      this.flag = false;
      console.log(rows[index].url);
      console.log(rows[index].filename);
      let obj = {};
      let murl = rows[index].url;
      let lname = rows[index].filename;
      let auth = "试听上传歌曲";
      obj.title = lname;
      obj.author = auth;
      obj.url = murl;
      //把数据一个个push到songList数组中，在a-player标签中使用 :music="songList" 就OK了
      this.songList = obj;
      this.flag = true;
      this.autoplay = true;
    },
    downloadurl(index, rows) {
      this.flag = false;
      console.log(rows[index].url);
      console.log(rows[index].filename);
      let obj = {};
      let murl = rows[index].url;
      let lname = rows[index].filename;
      let auth = "试听上传歌曲";
      obj.title = lname;
      obj.author = auth;
      obj.url = murl;
      //把数据一个个push到songList数组中，在a-player标签中使用 :music="songList" 就OK了
      this.songList = obj;
      this.flag = true;
      this.autoplay = true;
    },
    deleteRow(index, rows) {
      this.$confirm(
        "此操作将永久删除该文件, 是否继续?     " + rows[index].filename,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
            let data = new FormData();
            data.append("id", sessionStorage.getItem("id"));
            data.append("token", sessionStorage.getItem("token"));
            data.append("fileid",rows[index].id);
          axios
            .post("/user/delfile", data)
            .then(
              function(res) {
                if (res.data.res) {
                  rows.splice(index, 1);
                  this.get_file_list();
                  this.$message({
                    type: "success",
                    message: "删除成功!" + filename
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: "上传文件出错了!",
        type: "error"
      });
    },

    abletask(index, rows) {
      console.log("fuckser");
      axios
        .get("/Change_file_status.php", {
          params: {
            file_id: rows[index].id,
            enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist_s(rows[index].task_enable, index);
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
		shelltask(index, rows) {
		  console.log("fuckser");
		  axios
		    .get("/Change_fenxiang_status.php", {
		      params: {
		        file_id: rows[index].id,
		        ziuse: rows[index].ziuse
		      }
		    })
		    .then(
		      function(res) {
		        if (res.data.res) {
		          this._get_timer_tasklist_s(rows[index].task_enable, index);
		        }
		      }.bind(this)
		    )
		    .catch(function(res) {
		      console.log(res);
		    });
		},

    uploadbeforemp3(file) {
      var fileName = new Array();
      fileName = file.name.split(".");
      const extension = fileName[fileName.length - 1] === "mp3";
      const extension2 = fileName[fileName.length - 1] === "MP3";
      const isLt2M = file.size / 1024 / 1024 < 40;
      fileName = file.name.split(".");
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是MP3格式!",
          type: "warning"
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 40MB!",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    uploadSuccess(response, file, fileList) {

      if(response.res == true){
        this.$message({
          message: "文件上传成功！",
          type: "success"
        });
          this.get_file_list();
      }else{
        this.$message({
          message: "文件上传失败！【可能已经上上传过了这个文件，也可能是这个文件不能被正常解析】"+response.info,
          type: "warning"
        });
      }

    },
    uploadSuccessmp3(response, file, fileList) {
      console.log("上传文件", response);

      this.get_file_list();
    },
    get_file_list() {
			if(sessionStorage.getItem("master_id") > 0){
					this.isroot = false;
			}
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/listfile",  data)
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.filelist;
							console.log(this.tableDatafilelist);
              // this.tableDatafilelist.forEach((item, index) => {
              //   item.filename = Base64.decode(item.filenamebase64);
              //   item.filesize = item.filesize;
              // });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style   scoped>
#uoloaddiv33 {
  //  margin: 20px auto;
  margin: 20px;
  width: 1000px;
}
#topbuttn {
  width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/uploadfile.vue